import { defineComponent as _defineComponent } from 'vue'
import { unref, computed } from 'vue';
    import { useHotelDescriptionRepository } from '@entities/hotelDescription';
    import formatNumber from '@/js/common/Domain/Service/mixins/formatNumber';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'HotelDescriptionTerritory',
  setup(__props) {

    const { hotelDescriptionUpdateDate, hotelDescriptionTerritory } = useHotelDescriptionRepository();
    const isHotelDescriptionUpdateDateExists = computed(() => unref(hotelDescriptionUpdateDate).length > 0);
    const isHotelDescriptionTerritoryExists = computed(() => unref(hotelDescriptionTerritory).length > 0);

    const hotelDescriptionDateAndTerritory = computed(() => [...unref(hotelDescriptionUpdateDate), ...unref(hotelDescriptionTerritory)]);
    const firstColumnHotelDescriptionData = computed(() => unref(hotelDescriptionDateAndTerritory).filter((value, index) => index % 2 === 0));
    const secondColumnHotelDescriptionData = computed(() => unref(hotelDescriptionDateAndTerritory).filter((value, index) => index % 2 === 1));

return { __sfc: true,hotelDescriptionUpdateDate, hotelDescriptionTerritory, isHotelDescriptionUpdateDateExists, isHotelDescriptionTerritoryExists, hotelDescriptionDateAndTerritory, firstColumnHotelDescriptionData, secondColumnHotelDescriptionData, formatNumber }
}

})